import { PageHeader } from '../../../components/page-header'
import { useTicket } from '../../../hooks/useTicket'
import { useEffect, useState } from 'react'
import { BeatLoader } from 'react-spinners'
import { css } from "@emotion/react";
import moment from 'moment';
import { formatCnpjCpf } from '../../../utils/formatter';

import './styles.css'

export function BoletoList() {
  const { fetchTickets, boletos, boletosLoader, getBoletoBase64, getBoletoDetails } = useTicket();

  const [currentPage, setCurrentPage] = useState(1);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [boletoDetails, setBoletoDetails] = useState(null);
  const [detailsLoader, setDetailsLoader] = useState(false);

  const itemsPerPage = 15;

  useEffect(() => {
    fetchTickets();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [boletos]);

  const override = css`
    display: block;
    margin: 0 auto;
    margin-top: 3em;
  `;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = boletos.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(boletos.length / itemsPerPage);

  const generatePages = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(currentPage - 2, 1);
    let end = Math.min(start + maxVisible - 1, totalPages);

    if (end - start < maxVisible - 1) {
      start = Math.max(end - maxVisible + 1, 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const handlePrintSecondCopy = async (entryId) => {
    await getBoletoBase64(entryId);
    window.open('/boleto-emitido', '_blank');
  };

  const handleOpenDetails = async (documentNumber) => {
    setDetailsLoader(true);
    setBoletoDetails(null);

    const response = await getBoletoDetails(documentNumber);
    setBoletoDetails(response);

    setDetailsLoader(false);
    setOpenDropdown(null);
  };

  const closeModal = () => {
    setBoletoDetails(null);
  };

  const getBboletoStatus = (status) => {
    const statusMap = {
      0: 'Pendente',
      3: 'Registrado',
      5: 'Liquidado',
      7: 'Cancelado',
    };

    return statusMap[status] ?? 'Status desconhecido';
  }

  return (
    <div className='cobrar-boleto-container'>
      <PageHeader
        title='Boletos enviados'
        pages={[
          { name: 'Boleto', link: '/pagina-boleto' },
          { name: 'boletos emitidos', link: '' },
        ]}
      />

      <div className="boleto-list-content">
        {!boletosLoader ? (
          <>
            {boletos.length ? (
              <>
                <div className="table-responsive table-scroll">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Cliente</th>
                        <th>Data</th>
                        <th>CPF/CNPJ</th>
                        <th>Valor</th>
                        <th className="text-center">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((boleto) => (
                        <tr key={boleto.id}>
                          <td>{boleto.customerName}</td>
                          <td>{moment(boleto.createdAt).format('LLL')}</td>
                          <td>{formatCnpjCpf(boleto.customerTaxNumber)}</td>
                          <td>R$ {Number(boleto.totalValue).toFixed(2)}</td>

                          {/* COLUNA AÇÕES */}
                          <td className="text-center position-relative">
                            <button
                              className="dots-button"
                              onClick={() =>
                                setOpenDropdown(openDropdown === boleto.id ? null : boleto.id)
                              }
                            >
                              ⋮
                            </button>

                            {openDropdown === boleto.id && (
                              <div className="dropdown-menu-custom">
                                <button
                                  onClick={() =>
                                    handlePrintSecondCopy(boleto.entryId)
                                  }
                                >
                                  Imprimir 2ª via
                                </button>

                                <button
                                  onClick={() =>
                                    handleOpenDetails(boleto.documentNumber)
                                  }
                                >
                                  Ver detalhes
                                </button>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* PAGINAÇÃO */}
                <div className="pagination-saas">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    ‹
                  </button>

                  {generatePages().map((page) => (
                    <button
                      key={page}
                      className={page === currentPage ? 'active' : ''}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  ))}

                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    ›
                  </button>
                </div>
              </>
            ) : (
              <span className="empty-boletos">
                Nenhum resultado encontrado.
              </span>
            )}
          </>
        ) : (
          <div className="loader-div">
            <BeatLoader
              color={"var(--secondary-color)"}
              loading={boletosLoader}
              css={override}
              size={20}
            />
          </div>
        )}
      </div>

      {/* MODAL DETALHES */}
      {boletoDetails && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Detalhes do Boleto</h3>

            {detailsLoader ? (
              <BeatLoader size={15} />
            ) : (
              <>
                <p><strong>Cliente:</strong> {boletoDetails.customerName}</p>
                <p><strong>CPF/CNPJ:</strong> {formatCnpjCpf(boletoDetails.customerTaxNumber)}</p>
                <p><strong>Email:</strong> {boletoDetails.customerMail}</p>
                <p><strong>Telefone:</strong> {boletoDetails.customerPhone}</p>
                <p><strong>Valor:</strong> R$ {Number(boletoDetails.totalValue).toFixed(2)}</p>
                <p><strong>Vencimento:</strong> {moment(boletoDetails.dueDate).format('LL')}</p>
                <p><strong>Documento:</strong> {boletoDetails.documentNumber}</p>
                <p><strong>Identificador:</strong> {boletoDetails.identifier}</p>
                <p><strong>Status:</strong> {getBboletoStatus(boletoDetails.status)}</p>
              </>
            )}

            <button className="close-button" onClick={closeModal}>
              Fechar
            </button>
          </div>
        </div>
      )}
    </div>
  )
}